import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const LastReadIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M1.83301 16.7731C2.06908 17.0385 2.48846 17.075 2.77174 16.8564C3.05502 16.6351 3.09391 16.2421 2.86061 15.9766C1.90522 14.8965 1.3331 13.5118 1.3331 11.9996C1.3331 10.4873 1.908 9.10267 2.86061 8.02251C3.09391 7.75703 3.05503 7.36141 2.77174 7.14277C2.48846 6.92414 2.06631 6.96058 1.83301 7.22606C0.688769 8.52225 1.5837e-07 10.188 0 11.9996C-1.5837e-07 13.8111 0.688768 15.4769 1.83301 16.7731Z"
            fill="currentColor"
         />
         <path
            d="M3.11335 11.9996C3.11335 13.0589 3.49661 14.0349 4.14095 14.8106C4.36869 15.0839 4.78528 15.1333 5.0769 14.9199C5.36851 14.7065 5.4185 14.316 5.19354 14.0427C4.72418 13.4779 4.44645 12.77 4.44645 11.9996C4.44645 11.2291 4.72418 10.5212 5.19354 9.95638C5.4185 9.68309 5.36851 9.29007 5.0769 9.07924C4.78528 8.86842 4.36591 8.91527 4.14095 9.18856C3.49662 9.96419 3.11335 10.9402 3.11335 11.9996Z"
            fill="currentColor"
         />
         <path
            d="M22.167 7.22596C21.9309 6.96047 21.5115 6.92404 21.2283 7.14267C20.945 7.36391 20.9061 7.75693 21.1394 8.02241C22.0948 9.10256 22.6669 10.4872 22.6669 11.9995C22.6669 13.5117 22.092 14.8964 21.1394 15.9765C20.9061 16.242 20.945 16.6376 21.2283 16.8563C21.5115 17.0749 21.9337 17.0384 22.167 16.773C23.3112 15.4768 24 13.811 24 11.9995C24 10.1879 23.3112 8.52214 22.167 7.22596Z"
            fill="currentColor"
         />
         <path
            d="M20.8867 11.9995C20.8867 10.9401 20.5034 9.96408 19.8591 9.18846C19.6313 8.91516 19.2147 8.86571 18.9231 9.07914C18.6315 9.29257 18.5815 9.68298 18.8065 9.95628C19.2758 10.5211 19.5536 11.229 19.5536 11.9995C19.5536 12.7699 19.2758 13.4778 18.8065 14.0426C18.5815 14.3159 18.6315 14.709 18.9231 14.9198C19.2147 15.1306 19.6341 15.0838 19.8591 14.8105C20.5034 14.0348 20.8867 13.0588 20.8867 11.9995Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default LastReadIcon
